import type React from 'react';
import type { IconType } from 'react-icons';

interface CategoryBoxProps {
  id: string;
  icon: IconType;
  iconSize?: number;
  textSize?: string;
  label: string;
  selected?: boolean;
  onClick: () => void;
}

const CategoryBox: React.FC<CategoryBoxProps> = ({
  id,
  icon: Icon,
  iconSize,
  textSize,
  label,
  selected,
  onClick,
}) => (
  <button
    id={`category-btn-${id}`}
    key={`category-btn-${id}`}
    aria-label={label}
    data-test-id={`category-btn-${id}`}
    data-umami-event="category-clicked"
    data-umami-event-category={`category-${id}`}
    data-umami-event-label={label}
    className={`group flex min-h-full cursor-pointer flex-col items-center justify-center gap-2 border-b-2 p-2 transition hover:border-b-slate-800 hover:text-slate-800 ${
      selected ? 'border-b-slate-800' : 'border-transparent'
    } ${selected ? 'text-slate-800' : 'text-slate-500'}`}
    type="button"
    onClick={() => onClick()}
  >
    <Icon
      size={iconSize || 26}
      className={` group-hover:text-slate-800 ${
        selected ? 'text-slate-800' : 'text-slate-500'
      }`}
    />
    <div
      className={`${textSize || 'text-xs'} group-hover:font-bold ${
        selected ? 'font-bold' : 'font-semibold'
      }`}
    >
      {label}
    </div>
  </button>
);

export default CategoryBox;
